export default {
  logs: [],
  log: {},
  loading: false,
};
